//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import Services from "~/components/ohrany-zreniya/Services.vue";
export default BaseCmsBlock.extend({
  name: "LandingHealthBlock",
  created: async function () {
    const {data: services} = await this.$api.agent.transport.get('services?filter[category_id]=5').catch((err) => {
      return {data: []}
    });
    this.services = services;
  },

  data: function () {
    return {
      services: [],
    }
  },
  components: {
    Services
  }
})
